import { TextV2 } from '@insights-ltd/design-library/components';
import { Paper, Box, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

export const DisplayItem = ({
  name,
  Action,
  labelKey,
  tags,
}: {
  name: string | React.ReactNode;
  Action?: {
    text: string;
    onClick: () => void;
    color: 'primary' | 'secondary' | 'error' | 'buttonDark';
  };
  labelKey: string;
  tags?: React.ReactNode[];
}) => {
  const { t } = useTranslation();

  return (
    <Grid>
      <Grid
        container
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Grid>
          <TextV2 component="span" variant="bodyBold">
            {t(labelKey)}
          </TextV2>
        </Grid>
      </Grid>
      <Grid sx={{ marginTop: '0.5rem' }}>
        <Paper elevation={0} variant="outlined">
          <Box
            sx={{
              padding: '0.75rem 1rem 0.75rem 1.25rem',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            {name}
            {tags ? tags : null}

            {Action && Object.values(Action).every((values) => values) && (
              <Button
                onClick={Action.onClick}
                sx={{ minWidth: 0, padding: 0 }}
                color={Action.color}
              >
                {t(Action.text)}
              </Button>
            )}
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
